import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/builder',
    name: 'builder',
    component: () => import('../views/Builder.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
